import { jsx, jsxs } from "react/jsx-runtime";
import { node, bool, arrayOf, oneOfType, string, number, element, shape } from "prop-types";
import React, { useState } from "react";
import cx from "classnames";
import Hyperlink from "@ingka/hyperlink";
import { FormFieldProvider } from "./FormFieldContext";
import HelperText, { CharacterCount } from "@ingka/helper-text";
const propTypes = {
  /** Required children of type InputField, Checkbox or RadioButton */
  children: oneOfType([
    arrayOf(node),
    node
  ]),
  /** Validation message object */
  validation: shape({
    type: string,
    msg: oneOfType([element, string]),
    id: string,
    linkText: string,
    link: string
  }),
  /** When shouldValidate == false, helper message object */
  fieldHelper: shape({
    type: string,
    msg: oneOfType([element, string]),
    id: string,
    linkText: string,
    link: string
  }),
  /** Shows validation message if Form has validation rules set for this form field (if !valid) */
  shouldValidate: bool,
  /** Defines if the formfield is valid or not */
  valid: bool,
  /** Appends additional classes to FormField element. */
  className: string,
  /** Prefix all classes in every element with this string */
  prefix: string,
  /** Defines if the formfield is disabled or not */
  disabled: bool,
  characterLimit: number
};
const FormField = (props) => {
  const {
    prefix = "",
    characterLimit,
    children,
    validation = { type: "error" },
    fieldHelper = {},
    shouldValidate = false,
    valid,
    className,
    disabled,
    ...other
  } = props;
  const showValidation = shouldValidate && !valid;
  let { id, msg, linkText, link, type, ...messageProps } = showValidation ? validation : fieldHelper;
  if (!type && showValidation) {
    type = "error";
  }
  const baseClass = `${prefix}form-field`;
  const classes = cx(
    `${baseClass}`,
    type && `${baseClass}--${type}`,
    characterLimit && `${baseClass}--with-character-limit`,
    disabled && `${prefix}disabled`,
    className
  );
  const describedById = id;
  const [characterCount, setCharacterCount] = useState(0);
  const validCharacterLimit = characterLimit !== 0 && characterLimit > 0;
  return /* @__PURE__ */ jsx(
    FormFieldProvider,
    {
      valid,
      shouldValidate,
      setCharacterCount,
      children: /* @__PURE__ */ jsxs("div", { className: classes, ...other, children: [
        React.Children.map(children, (child) => {
          if (child.props.list)
            return child;
          const extraProps = { describedById: msg ? describedById : null };
          return React.cloneElement(child, extraProps);
        }),
        !disabled && (msg || validCharacterLimit) && /* @__PURE__ */ jsxs("div", { className: `${baseClass}__content`, children: [
          /* @__PURE__ */ jsxs(HelperText, { prefix, id, shouldValidate, valid, ...messageProps, children: [
            msg,
            linkText && link && /* @__PURE__ */ jsx(Hyperlink, { prefix, url: link, text: linkText })
          ] }),
          validCharacterLimit && /* @__PURE__ */ jsx(CharacterCount, { prefix, characterCount, limit: characterLimit })
        ] })
      ] })
    }
  );
};
FormField.propTypes = propTypes;
var FormField_default = FormField;
export {
  FormField_default as default
};
